import { get } from '@/plugins/axios.js'

// 如果我们的项目需要代理多个地址，就不能在axios中设置 axios.defaults.baseURL
// 应该在此处动态的拼接url！
const baseApi = process.env.VUE_APP_BASE_API

const spring2022 = {
  /**
   * 春运天气
   * @returns
   */
  getSpringWeather () {
    return get(`${baseApi}/data/link-tqbg/gz_tqbg.json`)
  },
  /**
   * 获取格点（giftDaily）数据
   * @param {Number} lon 精度
   * @param {Number} lat 纬度
   */
  getGiftDailyData (lon, lat) {
    const longitude = Math.floor(lon / 0.05) * 0.05
    const latitude = Math.floor(lat / 0.05) * 0.05
    const filename = ('giftDaily' + longitude.toFixed(2) + '_' + latitude.toFixed(2)).replace(/\./g, '')
    return get(`${baseApi}/data/giftDailyCache/${filename}.json`)
  },
  /**
   * 获取自动站实况数据
   */
  getObtData () {
    return get(`${baseApi}/data/gzWeather/obtData.json`)
  },
  /**
   * 广州各区数据
   */
  getObtAreaRep () {
    return get(`${baseApi}/data/obtAreaRep/gz_obtAreaRep.json`)
  },
  /**
   * 气象交通站
   * @returns
   */
  getTrafficsObt () {
    return get(`${baseApi}/data/gzWeather/trafficsObt.json`)
  },
  /**
   * 公路气象预报
   * @returns
   */
  getHighwayForecast () {
    return get(`${baseApi}/data/zhuanti/qggb.json`)
  },
  /**
   * 逐日预报
   * @returns
   */
  getWeatherForecastByDays () {
    return get(`${baseApi}/data/weatherForecastByDays/gz_weatherForecastByDays.json`)
  },
  /**
   * 省内城市天气预报
   * @returns
   */
  getProvinceCityForecast () {
    return get(`${baseApi}/data/gzWeather/provinceCityForecast.json`)
  },
  /**
   * 国内城市天气预报
   * @returns
   */
  getDomesticCityForecast () {
    return get(`${baseApi}/data/gzWeather/domesticCityForecast.json`)
  },
  /**
   * 全国春运天气
   * @returns
   */
  getSpringWeatherCountry () {
    return get(`${baseApi}/data/zhuanti/qgshort.json`)
  },
  /**
   * 国际城市预报
   * @returns
   */
  getInternationalData () {
    return get(`${baseApi}/data/gzWeather/word.json`)
  }
}
export default spring2022
